import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Teaser from "@/components/site/Teaser";
import UeberMich from "@/components/site/UeberMich";
import Kontakt from "@/components/site/Kontakt";
import Spenden from "@/components/site/Spenden";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <Teaser />
      <UeberMich />
      <Kontakt />
      <Spenden />
    </>
  );
}
